// CShoes - JS customizado consolidado
(function(){
  function shuffleEmAlta(){
    var grid=document.querySelector('ul[id$="__featured_collection1"]');
    if(!grid) return;
    var items=Array.prototype.slice.call(grid.children).filter(function(n){return n.classList&&n.classList.contains('grid__item');});
    if(items.length<2) return;
    for(var i=items.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=items[i]; items[i]=items[j]; items[j]=t; }
    items.forEach(function(n){ grid.appendChild(n); });
  }
  if(document.readyState!=="loading") shuffleEmAlta();
  else document.addEventListener("DOMContentLoaded", shuffleEmAlta);
})();


// ===== cs-banner-pixel: rastreamento de impressao e cliques do banner (slideshow_summer) via Meta Pixel =====
(function(){
  function fireFbq(eventName, params){
    if (typeof fbq === 'function') {
      fbq('trackCustom', eventName, params || {});
    }
  }

  function initBannerPixel(){
    var section = document.querySelector("section[id$='__slideshow_summer']");
    if (!section) return;

    // Impressao: dispara uma vez quando o banner entra na tela
    if ('IntersectionObserver' in window) {
      var seen = {};
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            var slide = entry.target;
            var id = slide.id;
            if (!seen[id]) {
              seen[id] = true;
              var label = id.indexOf('-1') !== -1 ? 'coleção_verão' : 'porque_cada_passo_conta';
              fireFbq('BannerView', { banner_slide: label });
            }
          }
        });
      }, { threshold: 0.5 });
      section.querySelectorAll('.slideshow__slide').forEach(function(slide){
        observer.observe(slide);
      });
    }

    // Cliques: qualquer link/botao dentro do banner
    section.addEventListener('click', function(e){
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.closest('.slider-buttons')) return;
      var slide = link.closest('.slideshow__slide');
      if (!slide) return;
      var slideLabel = 'desconhecido';
      if (slide) {
        slideLabel = slide.id.indexOf('-1') !== -1 ? 'coleção_verão' : 'porque_cada_passo_conta';
      }
      var actionLabel = (link.textContent || '').trim() || link.getAttribute('aria-label') || link.href || 'clique';
      fireFbq('BannerClick', { banner_slide: slideLabel, banner_action: actionLabel });
    });
  }

  if (document.readyState !== 'loading') initBannerPixel();
  else document.addEventListener('DOMContentLoaded', initBannerPixel);
})();


// ===== cs-banner-drag: navegacao por arrasto (mouse) no banner, sem setas visiveis =====
(function(){
  function initDrag(){
    var slider = document.querySelector("section[id$='__slideshow_summer'] .slider");
    if (!slider) return;

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    slider.addEventListener('mousedown', function(e){
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = slider.scrollLeft;
      slider.classList.add('cs-dragging');
    });

    window.addEventListener('mouseup', function(){
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('cs-dragging');
      var slideW = slider.clientWidth;
      var target = Math.round(slider.scrollLeft / slideW) * slideW;
      slider.scrollTo({ left: target, behavior: 'smooth' });
    });

    window.addEventListener('mousemove', function(e){
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 5) moved = true;
      slider.scrollLeft = startScroll - dx;
    });

    // Evita que o arrasto dispare clique em link/botao dentro do slide
    slider.addEventListener('click', function(e){
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  }

  if (document.readyState !== 'loading') initDrag();
  else document.addEventListener('DOMContentLoaded', initDrag);
})();
